export default __webpack_public_path__ + "2cb30ff42f6e1b1fdd1c043b0f278acf.gif";